import { useEffect } from 'react';

const useDocumentTitle = (title) => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title ? `${title}` : 'Depot de Dossier UAM';
    
    // Cleanup: restaurer le titre précédent quand le composant est démonté
    return () => {
      document.title = prevTitle;
    };
  }, [title]);
};

export default useDocumentTitle;
